export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
  ],
  months: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ],
  months_calendar: {
    January: '一月',
    February: '二月',
    March: '三月',
    April: '四月',
    May: '五月',
    June: '六月',
    July: '七月',
    August: '八月',
    September: '九月',
    October: '十月',
    November: '十一月',
    December: '十二月',
  },
  // weekdays
  weekdays: ['日', '一', '二', '三', '四', '五', '六'],
  weekdays_booking_container: {
    Sunday: '星期日',
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
  },
  weekdays_calendar: {
    Sun: '週日',
    Mon: '週一',
    Tue: '週二',
    Wed: '週三',
    Thu: '週四',
    Fri: '週五',
    Sat: '週六',
  },
  // additional translations
  today: '今天',
  tomorrow: '明天',
};
